import React from 'react';
import styled from 'styled-components';
import LoaderObj from 'react-loader-spinner';
import { Typography } from '@material-ui/core';

const BGLoading = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(255, 255, 255, 0.75);
`;

const Loader = (props) => {
  window.scrollTo(0, 0);

  return(
    <BGLoading>
      {props.message && (
        <Typography 
          variant="h6"
          align="center"
          className="bold-text"
          style={{
            width: "100%",
            position: "absolute",
            top: "42%",
            transform: "translateY(-50%)",
          }}
        >
          {props.message}
        </Typography>
      )}
      <LoaderObj
        type="ThreeDots"
        color="var(--secondary)"
        height={80}
        width={80}
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translateY(-50%) translateX(-50%)",
        }}
      />
    </BGLoading>
  );
};

export default Loader;